// extracted by mini-css-extract-plugin
export var bodyColor = "IWfYW";
export var container = "aPeQr";
export var miniatureContainer = "W5pCT";
export var spinner = "fc_Os";
export var textButtonContainer = "k1aiH";
export var textContainer = "PEPgk";